import { ReactNode, useState, useEffect } from 'react';
import { cmsApi } from '@commerce-webcomponents/sdk';
import { CmsPaymentMethodType } from '../types/propTypes';
import CMSImageContext from '../CMSImageContext';

const WithCMSImage = ({ children }: { children: ReactNode }) => {
  const [cmsImages, setCMSImages] = useState<CmsPaymentMethodType | undefined>();
  const fetchContentStackImages = async () => {
    const images = await cmsApi.fetchContent({
      uId: 'payment_methods',
    });
    setCMSImages(images as CmsPaymentMethodType);
  };
  useEffect(() => {
    fetchContentStackImages();
  }, []);

  return cmsImages?.methods?.length ? (
    <CMSImageContext.Provider value={cmsImages} data-testid="provider">
      {children}
    </CMSImageContext.Provider>
  ) : (
    <>{children}</>
  );
};

export default WithCMSImage;
